import { render, staticRenderFns } from "./ProjectModifyDetail.vue?vue&type=template&id=2fbb260c"
import script from "./ProjectModifyDetail.vue?vue&type=script&lang=js"
export * from "./ProjectModifyDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectModifyDetail.vue?vue&type=style&index=0&id=2fbb260c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports